import { Icon } from '@/components/Icon/Icon'

import { useNavigation } from '@/hooks/useNavigation'

import styles from './styles.module.scss'

export const Dropdown = ({ section, id, label, links, customClass }) => {
  const { urlParams } = useNavigation()

  return (
    <div className={styles.dropdown}>
      <div
        id={`${section}-${id}-dropdown`}
        key={`${section}-${id}-dropdown`}
        className={`
          ${styles.dropdown__button} 
          ${customClass}
        `}
      >
        {label}
        <Icon name="equifax-arrow-down" size="xs" />
      </div>

      <ul className={styles.dropdown__links}>
        {links.map((child) => (
          <li key={`${section}-${child.id}-link`}>
            <a
              rel="noreferrer"
              id={`${section}-${child.id}-link`}
              href={`${child.path}${urlParams}`}
              className={styles.dropdown__link}
            >
              {child.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
